import React from 'react';
import { Select } from 'antd';

const SelectImmunityType = ({ ...rest }) => {
  return (
    <Select {...rest}>
      <Select.Option value="notInformed">
        0 - Imunidade (tipo não informado na nota de origem)
      </Select.Option>
      <Select.Option value="governmentReciprocal">
        1 - Patrimônio, renda ou serviços, uns dos outros
      </Select.Option>
      <Select.Option value="religiousEntities">
        2 - Entidades religiosas e templos de qualquer culto, inclusive suas
        organizações assistenciais e beneficentes
      </Select.Option>
      <Select.Option value="nonProfitEntities">
        3 - Patrimônio, renda ou serviços dos partidos políticos, inclusive suas
        fundações, das entidades sindicais dos trabalhadores, das instituições
        de educação e de assistência social, sem fins lucrativos, atendidos os
        requisitos da lei
      </Select.Option>
      <Select.Option value="booksAndPeriodicals">
        4 - Livros, jornais, periódicos e o papel destinado a sua impressão
      </Select.Option>
      <Select.Option value="brazilianPhonograms">
        5 - Fonogramas e videofonogramas musicais produzidos no Brasil contendo
        obras musicais ou literomusicais de autores brasileiros e/ou obras em
        geral interpretadas por artistas brasileiros bem como os suportes
        materiais ou arquivos digitais que os contenham, salvo na etapa de
        replicação industrial de mídias ópticas de leitura a laser.
      </Select.Option>
    </Select>
  );
};

export default SelectImmunityType;
